// src/utils/axiosConfig.js
import axios from "axios";
import { showToast } from "../CoreDataService";

const setupAxiosInterceptors = () => {
  // Request interceptor
  axios.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem("access_token");
      if (token) {
        // config.headers['Authorization'] = `Bearer ${token}`;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

  // Response interceptor
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401) {
        // Clear auth tokens
        // localStorage.setItem("access_token", "");

        showToast("error", "Session timedout. Please login again");
        // localStorage.removeItem('uuid');

        // Redirect to login page
        localStorage.clear();
        window.location.href = "/";
        window.location.reload();
      }

      return Promise.reject(error);
    }
  );
};

export default setupAxiosInterceptors;
